var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSketch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vscode-icons:file-type-sketch"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.36581 4.52713L17.75 3.64844L26.1342 4.52819L32.625 13.1759L17.75 30.3533L2.875 13.1759L9.36581 4.52713Z",
    fill: "#FDB300"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.90044 13.1699L17.75 30.3527L2.875 13.1699H8.90044ZM26.5996 13.1699L17.75 30.3527L32.625 13.1699H26.5996Z",
    fill: "#EA6C00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.90234 13.1699H26.6015L17.7519 30.3527L8.90234 13.1699Z",
    fill: "#FDAD00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M17.7519 3.64844L9.36772 4.52713L8.90234 13.1706L17.7519 3.64844ZM17.7519 3.64844L26.1361 4.52713L26.6015 13.1706L17.7519 3.64844Z",
    fill: "#FDD231"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M32.625 13.1688L26.1342 4.52539L26.5996 13.1688H32.625ZM2.875 13.1688L9.36581 4.52539L8.90044 13.1688H2.875Z",
    fill: "#FDAD00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M17.7519 3.64844L8.90234 13.1706H26.6015L17.7519 3.64844Z",
    fill: "#FEEEB7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSketch);
export default __webpack_public_path__ + "static/media/sketch.6c52f788f92b7292b3aba3567206d720.svg";
export { ForwardRef as ReactComponent };